<style>
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

    .not-draggable {
        cursor: no-drop;
    }

    .list-block{
        background: #F5F5F5;
        /* width: 500px; */
        padding: 20px;
        cursor: pointer;
        margin-bottom: 1px;
        display: flex;
    }

    .red{
        background: #ffb7b7;

    }

    .list-block .icon{
        width: 10%;
    }

    .list-block .label{
        width: 50%;
    }

    .list-block .label-info{
        width: 80%;
    }

    .list-block .required{
        width: 30%;
        text-align:right;
        padding: 0 10px;
    }

    .list-block .display{
        width: 10%;
        text-align:right;
        padding: 0 10px;
    }

    .list-group{
        /* width: 500px; */
    }
    .tables-container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 20px;
    }
    .table-data{
      width: 200px;
      padding: 10px;
      border: 1px solid #ccc;
    }

    .table-data .table-body{
      height: 300px;
      overflow: auto;
    }

    .row-tblock {
      padding: 8px;
      margin-bottom: 4px;
      background-color: #f0f0f0;
      cursor: grab;
      font-size: 8pt;
    }

    .row-tblock .sub{
      font-size: 7pt;
    font-weight: 700;
    }
    
    .participant-container {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: flex-start;
      align-items: flex-start;
    }

    .participant-data {
      flex: 1;
    }
    .table-management {
      flex: 4;
      padding-left: 20px;
    }
</style>

<template>
  <b-card>
    <h4 v-if="currentObject.event_name" class="mb-2">
      Table Management <a :href="'/events/' + currentObject.event_id + '/view'">({{ currentObject.event_name }})</a>
    </h4>
    <div class="participant-container">
      <div class="participant-data">
        <b-button size="sm" variant="success" @click="save()">
          <feather-icon
            icon="SaveIcon"
            class="mr-50"
          /><span>Save Data</span>
        </b-button>
        <div style="clear: both" class="mb-1"></div>
        <div class="table-data">
          <h5>Participants</h5>
           <draggable
              :list="participants"
              :group="{ name: 'shared', pull: true, put: true }"
              @end="onDragEnd"
              item-key="id"
              class="table-body"
            >
              <div v-for="element in participants" :key="element.id">
                <div class="row-tblock">
                  {{ element.name }}<br>
                  <span class="sub">[{{ element.company }}]</span>
                </div>
              </div>
            </draggable>     
                
        </div>
      </div>
      <div class="table-management">
        <b-button size="sm" variant="primary" @click="addTable()">
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
          /><span>Add Table</span>
        </b-button>
        <div style="clear: both" class="mb-1"></div>
        <div class="tables-container">
          <div class="table-data" v-for="(list, index) in tables" :key="index">
            <input type="text" v-model="list.name" placeholder="Table Name" class="form-control mb-2" />
            
            <draggable
              :list="list.participants"
              :group="{ name: 'shared', pull: true, put: true }"
              @end="onDragEnd"
              item-key="id"
            >
              <div v-for="element in list.participants" :key="element.id">
                <div class="row-tblock">
                  {{ element.name }}<br>
                  <span class="sub">[{{ element.company }}]</span>
                </div>
              </div>
            </draggable>
            <b-button size="sm" variant="danger" class="mt-2" @click="removeTable(index)">
              <feather-icon
                icon="XIcon"
                class="mr-50"
              /><span>Remove Table</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BCard, BForm, BButton, BSpinner, BRow, BCol
} from 'bootstrap-vue'
import router from '@/router'
import { VueGoodTable } from 'vue-good-table'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import draggable from 'vuedraggable'


export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BForm,
    BButton,
    BSpinner,
    vSelect,
    BRow,
    BCol,
    draggable,
  },
  data() {
    return {
      currentObject: {
        user_id: -1,
        event_id: -1,
        event_name: null,
        event_code: null,
        whatsapp: null,
        additional_fields: null,
      },
      tables: [
      ],
      participants: [
      ],
    }
  },
  methods: {
    addTable() {
      this.tables.push({
        name : '',
        participants : [],
    })
    },
    removeTable(index) {
      this.tables[index].participants.forEach((participant) => {
        this.participants.push(participant)
      })
      this.tables.splice(index, 1)
    },
    fetchData() {
      this.isLoadingTable = true

      const id = router.currentRoute.params.id

      this.currentObject.event_id = id

      this.$http.get('/admin/v1/events/' + this.currentObject.event_id + '/register-open-sit')
        .then(res => {
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data
            currentData.forEach((item) => {
              this.participants.push({
                id: item.id,
                name: item.user_profile.registered_name+ " "+item.user_profile.registered_last_name,
                company: item.user_profile.company,
              })
            })
          }

          this.isLoadingTable = false

     })
    },

    fetchEvent() {
      this.isLoadingForm = true

      const id = router.currentRoute.params.id

      this.$http.get('/admin/v1/events/' + id)
        .then(res => {
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data
            this.tables = currentData.sitting_arangement ? JSON.parse(currentData.sitting_arangement) : []
            this.currentObject.event_name =  currentData.name
            this.currentObject.event_code =  currentData.code
            this.currentObject.whatsapp = currentData.whatsapp_message
            this.currentFields = []
            this.currentObject.additional_fields = []

            if(currentData.fields !== null) {
              currentData.fields.forEach((item) => {
                this.currentFields.push(item)

                item['value'] = null

                this.currentObject.additional_fields.push(item)
              })
            }
          }

          this.isLoadingForm = false
     })
    },
    save(){
      const payload = {
        tables: this.tables,
      }

      this.$http.post('/admin/v1/events/' + this.currentObject.event_id + '/assign-sit', payload)
        .then(res => {
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Success`,
                icon: 'CheckCircleIcon',
                variant: 'success',
                text: message,
              },
            })
          }

     })
    },
    onDragEnd(evt) {
      console.log('Drag ended:', evt);
    }
  },
  created() {
    this.fetchData()
    this.fetchEvent()
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>